export const TAGS_CATEGORY = "tags";
export const DEFINITION_SIZE_CATEGORY = "definition_size_category";
export const CHAT_SIZE_CATEGORY = "group_size_category";
export const TRANSLATED_LANGUAGES_CATEGORY = "translated_languages";
export const FEATURES_CATEGORY = "features";
export const EXCLUDED_REFINEMENT_PREFIX = "-";
export const UPDATE_SETTINGS_DEBOUNCE_TIME = 2000; // 2 seconds
